/* ============================================================
   TCC CALIBRATION RAIL — 2026-09-19
   Tracks scroll position (0–1) and moves the fiducial indicator
   along the fixed engraved scale in snippets/tcc-calibration-rail.liquid.
   rAF-throttled, passive scroll listener, no dependency on the
   theme's animations.aio setting or GSAP. Delete the script_tag in
   layout/theme.liquid to roll back.
   ============================================================ */
(function () {
  'use strict';

  var rail = document.querySelector('.tcc-calibration-rail');
  if (!rail) return;

  var scale = rail.querySelector('.tcc-calibration-rail__scale');
  var indicator = rail.querySelector('.tcc-calibration-rail__indicator');
  if (!scale || !indicator) return;

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) {
    indicator.style.transitionDuration = '0ms';
  }

  var ticking = false;

  function update() {
    ticking = false;

    var doc = document.documentElement;
    var scrollTop = window.pageYOffset || doc.scrollTop || 0;
    var scrollableHeight =
      (doc.scrollHeight || document.body.scrollHeight) - doc.clientHeight;

    var pct = scrollableHeight > 0
      ? Math.min(1, Math.max(0, scrollTop / scrollableHeight))
      : 0;

    var travel = scale.clientHeight - indicator.clientHeight;
    var y = travel > 0 ? pct * travel : 0;

    rail.style.setProperty('--tcc-scroll-y', y.toFixed(1) + 'px');
  }

  function onScrollOrResize() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  update();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize, { passive: true });
})();
